import { extract } from './extract.svelte.js';
/**
 * A reactive keyboard handler designed to make it easy to provide accessible interfaces for
 * list-styled UI components (accordions, listboxes, radio controls, etc)
 * @param options Options that determine how the list is navigated
 */
export default function useArrayKeyboardHandler(options) {
    let orientation = $derived(extract(options?.orientation) ?? 'undefined');
    let reverse = $derived(extract(options?.reverse) ?? false);
    let nextCodes = $derived.by(() => {
        if (!reverse) {
            switch (orientation) {
                case 'horizontal':
                    return ['ArrowRight'];
                case 'vertical':
                    return ['ArrowDown'];
                case 'undefined':
                    return ['ArrowRight', 'ArrowDown'];
            }
        }
        switch (orientation) {
            case 'horizontal':
                return ['ArrowLeft'];
            case 'vertical':
                return ['ArrowUp'];
            case 'undefined':
                return ['ArrowLeft', 'ArrowUp'];
        }
    });
    let previousCodes = $derived.by(() => {
        if (!reverse) {
            switch (orientation) {
                case 'horizontal':
                    return ['ArrowLeft'];
                case 'vertical':
                    return ['ArrowUp'];
                case 'undefined':
                    return ['ArrowLeft', 'ArrowUp'];
            }
        }
        switch (orientation) {
            case 'horizontal':
                return ['ArrowRight'];
            case 'vertical':
                return ['ArrowDown'];
            case 'undefined':
                return ['ArrowRight', 'ArrowDown'];
        }
    });
    let isNextKey = $derived.by(() => {
        return function (e) {
            return nextCodes.includes(e.code);
        };
    });
    let isPreviousKey = $derived.by(() => {
        return function (e) {
            return previousCodes.includes(e.key);
        };
    });
    return {
        get orientation() {
            return orientation;
        },
        get reverse() {
            return reverse;
        },
        get isNextKey() {
            return isNextKey;
        },
        get isPreviousKey() {
            return isPreviousKey;
        },
    };
}
